exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty-view[data-v-377ce8e4]{font-size:13px;text-align:center;margin:40px 0}", ""]);

// exports
